import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService} from './auth.service'
import { Observable } from 'rxjs/Observable';
import { tap, map, take } from 'rxjs/operators';


@Injectable()
export class PublicGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.auth.user.pipe(
            take(1),
            map(user => !user),
            tap(loggedOut => {
                if (!loggedOut) {
                    this.router.navigate(['/checkit-dashboard']);
                }
            })
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/core/public.guard.ts